import React from 'react';
import ReactDOM from 'react-dom';

import '@makerdao/ui-components-core/dist/styles/global.css';
import './global.css';

import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
